import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from '../ConfirmCancelDialog';
import { LanguageContext } from '../LanguageContext';
import LocalizedDatePicker from "../LocalizedDatePicker";

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniKustannuspaikka;
var iniEmo;

class TilitapahtumaEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        const data = props.Daatta.filter(function (d) {
            return d.riviAvain === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RiviAvain: data[0].riviAvain,
            EmoTilitapahtumaAvain: data[0].emoTilitapahtumaAvain,
            KustannuspaikkaAvain: data[0].kustannuspaikkaAvain,
            TapahtumaAika: dayjs(data[0].tapahtumaAika),
            Tosite: data[0].tosite,
            Tositelaji: data[0].tositelaji,
            Tilinumero: data[0].tilinumero,
            Tilinimi: data[0].tilinimi,
            Yritys: data[0].yritys,
            Selite: data[0].selite,
            Projekti: data[0].projekti,
            Summa: data[0].summa,
            TapahtumaTyyppi: data[0].tapahtumaTyyppi,
            AlvKoodi: data[0].alvKoodi,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            tilitapahtumat: (Object.keys(props.lookupLists.tilitapahtumat).map((d) => ({ value: d, label: props.lookupLists.tilitapahtumat[d] })) || []),
            kustannuspaikat: (Object.keys(props.lookupLists.kustannuspaikat).map((d) => ({ value: d, label: props.lookupLists.kustannuspaikat[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniKustannuspaikka = this.state.kustannuspaikat.find(({ value }) => value === (this.state.KustannuspaikkaAvain || '').toString());
        iniEmo = this.state.tilitapahtumat.find(({ value }) => value === (this.state.EmoTilitapahtumaAvain || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: this.state.data[0].riviAvain,
            EmoTilitapahtumaAvain: this.state.data[0].emoTilitapahtumaAvain,
            KustannuspaikkaAvain: this.state.data[0].kustannuspaikkaAvain,
            TapahtumaAika: dayjs(this.state.data[0].tapahtumaAika),
            Tosite: this.state.data[0].tosite,
            Tositelaji: this.state.data[0].tositelaji,
            Tilinumero: this.state.data[0].tilinumero,
            Tilinimi: this.state.data[0].tilinimi,
            Yritys: this.state.data[0].yritys,
            Selite: this.state.data[0].selite,
            Projekti: this.state.data[0].projekti,
            Summa: this.state.data[0].summa,
            TapahtumaTyyppi: this.state.data[0].tapahtumaTyyppi,
            AlvKoodi: this.state.data[0].alvKoodi,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            EmoTilitapahtumaAvain: this.state.EmoTilitapahtumaAvain,
            KustannuspaikkaAvain: this.state.KustannuspaikkaAvain,
            TapahtumaAika: this.state.TapahtumaAika.format("MM/DD/YYYY 00:00:00"),
            Tosite: this.state.Tosite,
            Tositelaji: this.state.Tositelaji,
            Tilinumero: this.state.Tilinumero,
            Tilinimi: this.state.Tilinimi,
            Yritys: this.state.Yritys,
            Selite: this.state.Selite,
            Projekti: this.state.Projekti,
            Summa: (this.state.Summa || "").toString().replace(",", "."),
            TapahtumaTyyppi: this.state.TapahtumaTyyppi,
            AlvKoodi: this.state.AlvKoodi,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleChangeDate = (name, value) => {
        this.setState({
            [name]: value,
            jotainMuuttui: true
        });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, tilitapahtumat, kustannuspaikat } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.DataIngestion.Tilitapahtuma.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniEmo}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'EmoTilitapahtumaAvain')}
                                options={tilitapahtumat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.DataIngestion.Tilitapahtuma.Columns[1]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniKustannuspaikka}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'KustannuspaikkaAvain')}
                                options={kustannuspaikat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.DataIngestion.Tilitapahtuma.Columns[2]} />}
                            />
                        </Box>
                        <LocalizedDatePicker
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[3]}
                            value={this.state.TapahtumaAika}
                            onChange={(newValue) => this.handleChangeDate('TapahtumaAika', newValue)}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Tosite}
                            onChange={this.handleChange('Tosite')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Tositelaji}
                            onChange={this.handleChange('Tositelaji')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Tilinumero}
                            onChange={this.handleChange('Tilinumero')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.Tilinimi}
                            onChange={this.handleChange('Tilinimi')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.Yritys}
                            onChange={this.handleChange('Yritys')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.Selite}
                            onChange={this.handleChange('Selite')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.Projekti}
                            onChange={this.handleChange('Projekti')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[11]}
                            type="text"
                            fullWidth
                            value={this.state.Summa}
                            onChange={this.handleChange('Summa')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[12]}
                            type="text"
                            fullWidth
                            value={this.state.TapahtumaTyyppi}
                            onChange={this.handleChange('TapahtumaTyyppi')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.Tilitapahtuma.Columns[13]}
                            type="text"
                            fullWidth
                            value={this.state.AlvKoodi}
                            onChange={this.handleChange('AlvKoodi')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "TilitapahtumaEdit" })(TilitapahtumaEdit);
